import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Unit_instanceat14thlj150z as Unit_instance,
  fill2542d4m9l93pn as fill,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Long2qws0ah9gnpki as Long,
  toLongw1zpgk99d84b as toLong,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  toByte4i43936u611k as toByte,
  VOID7hggqo3abtya as VOID,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toShort36kaw0zjdq3ex as toShort,
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
  createThis2j2avj17cvnv2 as createThis,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  protoOf180f3jzyo7rfj as protoOf,
  arrayCopytctsywo3h7gj as arrayCopy,
  isInterface3d6p8outrmvmk as isInterface,
  numberToLong1a4cndvg6c52s as numberToLong,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  KProperty02ce7r476m8633 as KProperty0,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  lazy2hsh8ze7j6ikd as lazy,
  toHexString18s73ly43cg6d as toHexString,
  toHexString22imn3z7nuei9 as toHexString_0,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
} from './kotlin-kotlin-stdlib.mjs';
import {
  AsyncGetLengthStream219k26r6v6js2 as AsyncGetLengthStream,
  MemorySyncStream1uv927me2xl9s as MemorySyncStream,
  write81fg3kayjaelgo as write8,
  AsyncGetPositionStream2f8n5516y4rp7 as AsyncGetPositionStream,
  hasAvailable2aj6ejlir0a2a as hasAvailable,
  getAvailable3luskqy8lu1u2 as getAvailable,
  readBytesExact305h8zdeltghk as readBytesExact,
  write88m676whmym9y as write8_0,
  write16LE1hc231hmo94he as write16LE,
  writeBytes51i911pexb89 as writeBytes,
  asyncStreamWriter3ock1ljgyrdbd as asyncStreamWriter,
  openSync2m3qn99fqytu0 as openSync,
  AsyncOutputStreamkoco1dsjo5gm as AsyncOutputStream,
  toAsync26jtc2k5wi4gn as toAsync,
  toAsync2pa2d6thtq8t4 as toAsync_0,
  write32LE1tnk0giwkbrpc as write32LE,
  write$default33b74pnsnzha9 as write$default,
  write32BE21w0wpwitaypp as write32BE,
  writewjg6v0v9v7gt as write,
} from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import {
  ByteArrayBuilderyrflhqjz64ju as ByteArrayBuilder,
  unsupported198cz39rr1ztw as unsupported,
  invalidOp1stebxh2m3n07 as invalidOp,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  ASCII_getInstancey3nspn0nzsaa as ASCII_getInstance,
  toString2x583ovdqfjci as toString_0,
} from './korlibs-string-root-korlibs-string.mjs';
import {
  SimpleRingBuffer1a4k3g2va6i8y as SimpleRingBuffer,
  getU16LE2cizldw8qp53x as getU16LE,
  getS32LE1pxm9wohin3g8 as getS32LE,
  getS32BE5aphh7sm8f2q as getS32BE,
} from './korlibs-memory-root-korlibs-memory.mjs';
import { runBlockingNoSuspensions25hsuevf2mle as runBlockingNoSuspensions } from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  CRC32_getInstance38eqfkdpicymh as CRC32_getInstance,
  Adler32_instance33daqpim0ep9p as Adler32_instance,
} from './korlibs-checksum-root-korlibs-checksum.mjs';
import { extract2vhru1ihy4ogl as extract } from './korlibs-math-core-root-korlibs-math-core.mjs';
//region block: imports
var clz32 = Math.clz32;
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    this.t23_1 = 8388608;
    this.u23_1 = 131072;
  }
}
class Companion_0 {
  constructor() {
    this.v23_1 = -1;
    this.w23_1 = -2;
    this.x23_1 = 1023;
    this.y23_1 = 16;
    this.z23_1 = 288;
    this.a24_1 = true;
    this.b24_1 = true;
    this.c24_1 = 10;
  }
}
class SlidingWindowWithOutput {
  constructor(sliding, out, flushSize, extraSize) {
    flushSize = flushSize === VOID ? 8388608 : flushSize;
    extraSize = extraSize === VOID ? 131072 : extraSize;
    this.w24_1 = sliding;
    this.x24_1 = out;
    this.y24_1 = flushSize;
    this.z24_1 = extraSize;
    this.a25_1 = FixedSizeByteArrayBuilder.x25(this.y24_1 + this.z24_1 | 0);
  }
  d25() {
    return this.a25_1.c25_1 >= this.y24_1;
  }
  s25(distance, length) {
    var inductionVariable = 0;
    if (inductionVariable < length)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v = this.w24_1.c26(distance);
        this.a25_1.wv(toByte(v));
      }
       while (inductionVariable < length);
  }
  w25(bytes, offset, len) {
    this.a25_1.uv(bytes, offset, len);
    this.w24_1.d26(bytes, offset, len);
  }
  t25(byte) {
    this.a25_1.wv(byte);
    this.w24_1.e26(get_unsigned(byte));
  }
}
class CompressionMethod {}
function get_level() {
  return 6;
}
function uncompress(i, o, $completion) {
  unsupported();
}
function compress(i, o, context, $completion) {
  unsupported();
}
class IDeflaterInternal {}
function uncompress_0(i, o, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_uncompress__ej2bxp_0.bind(VOID, this, i, o), $completion);
}
function compress_0(i, o, context, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_compress__c9auau_0.bind(VOID, this, i, o, context), $completion);
}
class DeflaterPortable {
  constructor(windowBits) {
    Companion_getInstance_1();
    this.t24_1 = windowBits;
  }
  f26(i, o, level, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_compress__c9auau.bind(VOID, this, i, o, level), $completion);
  }
  h26(reader, out, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_uncompress__ej2bxp.bind(VOID, this, reader, out), $completion);
  }
}
class Companion_1 extends DeflaterPortable {
  constructor() {
    Companion_instance_1 = null;
    super(15);
    Companion_instance_1 = this;
    var tmp = this;
    var tmp_0 = new HuffmanTree();
    // Inline function 'kotlin.apply' call
    var this_0 = new Int32Array(288);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.compression.deflate.Companion.FIXED_TREE.<anonymous>' call
    var inductionVariable = 0;
    if (inductionVariable <= 143)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0[n] = 8;
      }
       while (inductionVariable <= 143);
    var inductionVariable_0 = 144;
    if (inductionVariable_0 <= 255)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this_0[n_0] = 9;
      }
       while (inductionVariable_0 <= 255);
    var inductionVariable_1 = 256;
    if (inductionVariable_1 <= 279)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        this_0[n_1] = 7;
      }
       while (inductionVariable_1 <= 279);
    var inductionVariable_2 = 280;
    if (inductionVariable_2 <= 287)
      do {
        var n_2 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        this_0[n_2] = 8;
      }
       while (inductionVariable_2 <= 287);
    tmp.i25_1 = tmp_0.p25(this_0);
    var tmp_1 = this;
    var tmp_2 = new HuffmanTree();
    var tmp_3 = 0;
    var tmp_4 = new Int32Array(32);
    while (tmp_3 < 32) {
      tmp_4[tmp_3] = 5;
      tmp_3 = tmp_3 + 1 | 0;
    }
    tmp_1.j25_1 = tmp_2.p25(tmp_4);
    var tmp_5 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_5.k25_1 = new Int32Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0]);
    var tmp_6 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_6.l25_1 = new Int32Array([3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0]);
    var tmp_7 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_7.m25_1 = new Int32Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]);
    var tmp_8 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_8.n25_1 = new Int32Array([1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0]);
    var tmp_9 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_9.o25_1 = new Int32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
  }
}
class HuffmanTree {
  constructor() {
    this.d24_1 = new Int32Array(1024);
    this.e24_1 = new Int32Array(1024);
    this.f24_1 = new Int32Array(1024);
    this.g24_1 = 0;
    this.h24_1 = 1023;
    this.i24_1 = 0;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = new Int32Array(1024);
    while (tmp_0 < 1024) {
      tmp_1[tmp_0] = -1;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.j24_1 = tmp_1;
    var tmp_2 = this;
    var tmp_3 = 0;
    var tmp_4 = new Int32Array(1024);
    while (tmp_3 < 1024) {
      tmp_4[tmp_3] = 0;
      tmp_3 = tmp_3 + 1 | 0;
    }
    tmp_2.k24_1 = tmp_4;
    this.l24_1 = new Int32Array(17);
    this.m24_1 = new Int32Array(17);
    this.n24_1 = new Int32Array(17);
    this.o24_1 = new Int32Array(288);
  }
  q25(reader) {
    reader.k26(10);
    var node = this.h24_1;
    if (true && reader.n26() >= 10) {
      var bits = reader.l26(10);
      var raw = this.j24_1[bits];
      var value = toShort(raw);
      var len = raw >> 16;
      if (len > 0) {
        reader.m26(len);
        if (value === -2) {
          node = this.k24_1[bits];
        } else {
          return value;
        }
      }
    }
    $l$1: do {
      $l$0: do {
        var tmp;
        if (reader.f25()) {
          // Inline function 'korlibs.compression.deflate.HuffmanTree.right' call
          var this_0 = node;
          tmp = this.f24_1[this_0];
        } else {
          // Inline function 'korlibs.compression.deflate.HuffmanTree.left' call
          var this_1 = node;
          tmp = this.e24_1[this_1];
        }
        node = tmp;
      }
       while (false);
      var tmp_0;
      if (!(node === 1023)) {
        // Inline function 'korlibs.compression.deflate.HuffmanTree.value' call
        var this_2 = node;
        tmp_0 = this.d24_1[this_2] === -1;
      } else {
        tmp_0 = false;
      }
    }
     while (tmp_0);
    // Inline function 'korlibs.compression.deflate.HuffmanTree.value' call
    var this_3 = node;
    return this.d24_1[this_3];
  }
  r25(codeLengths, start, end) {
    var oldOffset = 0;
    var oldCount = 0;
    var ncodes = end - start | 0;
    resetAlloc(this);
    fill(this.l24_1, 0);
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var codeLen = codeLengths[n];
        if (!(0 <= codeLen ? codeLen <= 16 : false)) {
          // Inline function 'kotlin.error' call
          var message = 'Invalid HuffmanTree.codeLengths ' + codeLen;
          throw IllegalStateException.l5(toString(message));
        }
        var _array__4zh2yp = this.l24_1;
        _array__4zh2yp[codeLen] = _array__4zh2yp[codeLen] + 1 | 0;
      }
       while (inductionVariable < end);
    var currentOffset = 0;
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < 16)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var count = this.l24_1[n_0];
        this.m24_1[n_0] = currentOffset;
        this.n24_1[n_0] = currentOffset;
        currentOffset = currentOffset + count | 0;
      }
       while (inductionVariable_0 < 16);
    var inductionVariable_1 = start;
    if (inductionVariable_1 < end)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var codeLen_0 = codeLengths[n_1];
        var _array__4zh2yp_0 = this.n24_1;
        var _unary__edvuaz = _array__4zh2yp_0[codeLen_0];
        _array__4zh2yp_0[codeLen_0] = _unary__edvuaz + 1 | 0;
        this.o24_1[_unary__edvuaz] = n_1 - start | 0;
      }
       while (inductionVariable_1 < end);
    var inductionVariable_2 = 16;
    if (1 <= inductionVariable_2)
      do {
        var i = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + -1 | 0;
        var newOffset = this.g24_1;
        var OFFSET = this.m24_1[i];
        var SIZE = this.l24_1[i];
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < SIZE)
          do {
            var j = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            allocLeaf(this, this.o24_1[OFFSET + j | 0]);
          }
           while (inductionVariable_3 < SIZE);
        var progression = step(until(0, oldCount), 2);
        var inductionVariable_4 = progression.d2_1;
        var last = progression.e2_1;
        var step_0 = progression.f2_1;
        if (step_0 > 0 && inductionVariable_4 <= last || (step_0 < 0 && last <= inductionVariable_4))
          do {
            var j_0 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + step_0 | 0;
            allocNode(this, oldOffset + j_0 | 0, (oldOffset + j_0 | 0) + 1 | 0);
          }
           while (!(j_0 === last));
        oldOffset = newOffset;
        oldCount = SIZE + (oldCount / 2 | 0) | 0;
        if (oldCount >= 2 && !((oldCount % 2 | 0) === 0)) {
          // Inline function 'kotlin.error' call
          var message_0 = 'This canonical code does not represent a Huffman code tree: ' + oldCount;
          throw IllegalStateException.l5(toString(message_0));
        }
      }
       while (1 <= inductionVariable_2);
    if (!(oldCount === 2)) {
      // Inline function 'kotlin.error' call
      var message_1 = 'This canonical code does not represent a Huffman code tree';
      throw IllegalStateException.l5(toString(message_1));
    }
    this.h24_1 = allocNode(this, this.g24_1 - 2 | 0, this.g24_1 - 1 | 0);
    this.i24_1 = ncodes;
    computeFastLookup(this);
    return this;
  }
  p25(codeLengths, start, end, $super) {
    start = start === VOID ? 0 : start;
    end = end === VOID ? codeLengths.length : end;
    return $super === VOID ? this.r25(codeLengths, start, end) : $super.r25.call(this, codeLengths, start, end);
  }
}
class SlidingWindow {
  constructor(nbits) {
    this.y25_1 = nbits;
    this.z25_1 = new Int8Array(1 << this.y25_1);
    this.a26_1 = this.z25_1.length - 1 | 0;
    this.b26_1 = 0;
  }
  d1(offset) {
    return this.z25_1[(this.b26_1 - offset | 0) & this.a26_1] & 255;
  }
  c26(offset) {
    return this.e26(this.d1(offset));
  }
  e26(value) {
    this.z25_1[this.b26_1] = toByte(value);
    this.b26_1 = (this.b26_1 + 1 | 0) & this.a26_1;
    return value;
  }
  d26(bytes, offset, len) {
    var inductionVariable = 0;
    if (inductionVariable < len)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.e26(get_unsigned(bytes[offset + n | 0]));
      }
       while (inductionVariable < len);
  }
}
class FixedSizeByteArrayBuilder {
  static o26(data) {
    var $this = createThis(this);
    $this.b25_1 = data;
    $this.c25_1 = 0;
    return $this;
  }
  static x25(size) {
    return this.o26(new Int8Array(size));
  }
  m3() {
    this.c25_1 = 0;
  }
  uv(array, offset, len) {
    arraycopy(array, offset, this.b25_1, this.c25_1, len);
    this.c25_1 = this.c25_1 + len | 0;
  }
  wv(v) {
    var _unary__edvuaz = this.c25_1;
    this.c25_1 = _unary__edvuaz + 1 | 0;
    this.b25_1[_unary__edvuaz] = v;
  }
}
class Companion_2 {
  constructor() {
    this.p26_1 = 8388608;
    this.q26_1 = 32768;
  }
  r26(s, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_forInput__mjt6c9.bind(VOID, this, s), $completion);
  }
}
class BitReader {
  constructor(s, bigChunkSize, readWithSize) {
    bigChunkSize = bigChunkSize === VOID ? 8388608 : bigChunkSize;
    readWithSize = readWithSize === VOID ? 32768 : readWithSize;
    this.s26_1 = s;
    this.t26_1 = bigChunkSize;
    this.u26_1 = readWithSize;
    this.v26_1 = 0;
    this.w26_1 = 0;
    this.x26_1 = new SimpleRingBuffer(ilog2(get_nextPowerOfTwo(this.t26_1)));
    this.y26_1 = 0.0;
    this.z26_1 = 0.0;
    this.a27_1 = new Int8Array(4);
  }
  toString() {
    return 'BitReader(' + toString(this.s26_1) + ', bigChunkSize=' + this.t26_1 + ', readWithSize=' + this.u26_1 + ')';
  }
  d27() {
    return this.x26_1.e16_1 < this.u26_1;
  }
  b27(expectedBytes, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_prepareBytesUpTo__5zpo26.bind(VOID, this, expectedBytes), $completion);
  }
  k26(bitcount) {
    while (this.w26_1 < bitcount) {
      var tmp = this;
      var tmp_0 = this.v26_1;
      // Inline function 'korlibs.compression.deflate.BitReader._su8' call
      this.y26_1 = this.y26_1 + 1;
      tmp.v26_1 = tmp_0 | this.x26_1.e17() << this.w26_1;
      this.w26_1 = this.w26_1 + 8 | 0;
    }
  }
  l26(bitcount) {
    return this.v26_1 & ((1 << bitcount) - 1 | 0);
  }
  m26(bitcount) {
    this.v26_1 = this.v26_1 >>> bitcount | 0;
    this.w26_1 = this.w26_1 - bitcount | 0;
  }
  g25(bitcount) {
    this.k26(bitcount);
    var readed = this.l26(bitcount);
    this.m26(bitcount);
    return readed;
  }
  f25() {
    return !(this.g25(1) === 0);
  }
  e27(count, out) {
    var offset = 0;
    var count_0 = count;
    if (this.w26_1 >= 8) {
      if (!((this.w26_1 % 8 | 0) === 0)) {
        var bits = this.w26_1 % 8 | 0;
        this.m26(bits);
      }
      while (this.w26_1 >= 8) {
        var byte = toByte(this.g25(8));
        var _unary__edvuaz = offset;
        offset = _unary__edvuaz + 1 | 0;
        out[_unary__edvuaz] = byte;
        count_0 = count_0 - 1 | 0;
      }
    }
    // Inline function 'korlibs.compression.deflate.BitReader.discardBits' call
    this.v26_1 = 0;
    this.w26_1 = 0;
    var readCount = this.x26_1.o16(out, offset, count_0);
    if (readCount > 0)
      this.y26_1 = this.y26_1 + readCount;
  }
  c27(count, out) {
    this.e27(count, out);
    return out;
  }
  f27() {
    // Inline function 'korlibs.compression.deflate.BitReader._su8' call
    // Inline function 'korlibs.compression.deflate.BitReader.discardBits' call
    this.v26_1 = 0;
    this.w26_1 = 0;
    this.y26_1 = this.y26_1 + 1;
    return this.x26_1.e17();
  }
  u25() {
    this.e27(2, this.a27_1);
    return getU16LE(this.a27_1, 0);
  }
  g27() {
    this.e27(4, this.a27_1);
    return getS32LE(this.a27_1, 0);
  }
  h27() {
    this.e27(4, this.a27_1);
    return getS32BE(this.a27_1, 0);
  }
  i27(count, out, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_abytes__gje57m.bind(VOID, this, count, out), $completion);
  }
  j27(count, out, $completion, $super) {
    out = out === VOID ? new Int8Array(count) : out;
    return $super === VOID ? this.i27(count, out, $completion) : $super.i27.call(this, count, out, $completion);
  }
  l1s(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe.bind(VOID, this, buffer, offset, len), $completion);
  }
  m1s($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_close__nh2uv0.bind(VOID, this), $completion);
  }
  k27($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_strz__qhnc5d.bind(VOID, this), $completion);
  }
  u1v($completion) {
    return numberToLong(this.y26_1);
  }
  d1v($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_hasLength__5f5ox8.bind(VOID, this), $completion);
  }
  c1v($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getLength__lvva94.bind(VOID, this), $completion);
  }
}
class toDeflater$1 {
  constructor($this_toDeflater) {
    this.l27_1 = $this_toDeflater;
  }
  u24() {
    return this.l27_1.t26_1;
  }
  v24() {
    return this.l27_1.u26_1;
  }
  n26() {
    return this.l27_1.w26_1;
  }
  k26(bits) {
    return this.l27_1.k26(bits);
  }
  t1w($completion) {
    return hasAvailable(this.l27_1, $completion);
  }
  u1w($completion) {
    return getAvailable(this.l27_1, $completion);
  }
  v25(count, $completion) {
    return this.l27_1.j27(count, VOID, $completion);
  }
  u25() {
    return this.l27_1.u25();
  }
  f25() {
    return this.l27_1.f25();
  }
  m26(bits) {
    return this.l27_1.m26(bits);
  }
  l26(count) {
    return this.l27_1.l26(count);
  }
  g25(count) {
    return this.l27_1.g25(count);
  }
  r24(count, $completion) {
    return readBytesExact(this.l27_1, count, $completion);
  }
  e25($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_prepareBigChunkIfRequired__yhuuys.bind(VOID, this), $completion);
  }
}
class toDeflater$2 {
  constructor($this_toDeflater) {
    this.m27_1 = $this_toDeflater;
  }
  j1s(bytes, offset, size, $completion) {
    return this.m27_1.j1s(bytes, offset, size, $completion);
  }
  p24(value, $completion) {
    return write8_0(this.m27_1, value, $completion);
  }
  q24(value, $completion) {
    return write16LE(this.m27_1, value, $completion);
  }
  s24(bytes, $completion) {
    return writeBytes(this.m27_1, bytes, $completion);
  }
}
class CompressionContext {
  constructor(level) {
    level = level === VOID ? 6 : level;
    this.n27_1 = level;
    this.o27_1 = null;
    this.p27_1 = null;
  }
}
class uncompressStream$slambda {
  constructor($this_uncompressStream, $input) {
    this.q27_1 = $this_uncompressStream;
    this.r27_1 = $input;
  }
  s27(output, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, output), $completion);
  }
  ge(p1, $completion) {
    return this.s27((!(p1 == null) ? isInterface(p1, AsyncOutputStream) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class uncompress$slambda {
  constructor($this_uncompress, $i, $o) {
    this.t27_1 = $this_uncompress;
    this.u27_1 = $i;
    this.v27_1 = $o;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
  }
}
class compress$slambda {
  constructor($this_compress, $i, $o, $context) {
    this.w27_1 = $this_compress;
    this.x27_1 = $i;
    this.y27_1 = $o;
    this.z27_1 = $context;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
  }
}
class GZIPBase {
  constructor(checkCrc, deflater) {
    this.a28_1 = checkCrc;
    this.b28_1 = deflater;
  }
  toString() {
    return 'GZIPBase(' + this.a28_1 + ', ' + toString(this.b28_1) + ')';
  }
  i26(i, out, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_uncompress__ej2bxp_1.bind(VOID, this, i, out), $completion);
  }
  g26(i, o, context, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_compress__c9auau_1.bind(VOID, this, i, o, context), $completion);
  }
}
class GZIP extends GZIPBase {
  constructor(deflater) {
    Companion_getInstance_3();
    super(true, deflater);
  }
}
class Companion_3 extends GZIP {
  constructor() {
    Companion_instance_3 = null;
    super(GZIP$Companion$_init_$lambda_4zsoc7);
    Companion_instance_3 = this;
  }
  toString() {
    return 'GZIP';
  }
}
class GZIPBase$uncompress$2 {
  constructor($out, $ccrc32, $csize) {
    this.d28_1 = $out;
    this.e28_1 = $ccrc32;
    this.f28_1 = $csize;
    this.c28_1 = $out;
  }
  n1s(byte, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l.bind(VOID, this, byte), $completion);
  }
  m1s($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_close__nh2uv0_0.bind(VOID, this), $completion);
  }
  j1s(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_0.bind(VOID, this, buffer, offset, len), $completion);
  }
}
class GZIPBase$compress$2 {
  constructor($i, $crc32, $size) {
    this.h28_1 = $i;
    this.i28_1 = $crc32;
    this.j28_1 = $size;
    this.g28_1 = $i;
  }
  m1s($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_close__nh2uv0_1.bind(VOID, this), $completion);
  }
  u1v($completion) {
    return this.g28_1.u1v($completion);
  }
  d1v($completion) {
    return this.g28_1.d1v($completion);
  }
  c1v($completion) {
    return this.g28_1.c1v($completion);
  }
  l1s(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_0.bind(VOID, this, buffer, offset, len), $completion);
  }
}
class ZLib {
  constructor(deflater) {
    Companion_getInstance_4();
    this.p28_1 = deflater;
  }
  i26(i, o, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_uncompress__ej2bxp_2.bind(VOID, this, i, o), $completion);
  }
  g26(i, o, context, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_compress__c9auau_2.bind(VOID, this, i, o, context), $completion);
  }
}
class Companion_4 extends ZLib {
  constructor() {
    Companion_instance_4 = null;
    super(ZLib$Companion$_init_$lambda_nrgg4o);
    Companion_instance_4 = this;
  }
}
class ZLib$uncompress$2 {
  constructor($o, $chash) {
    this.k28_1 = $o;
    this.l28_1 = $chash;
  }
  m1s($completion) {
    return this.k28_1.m1s($completion);
  }
  j1s(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_1.bind(VOID, this, buffer, offset, len), $completion);
  }
}
class ZLib$compress$2 {
  constructor($i, $adler) {
    this.n28_1 = $i;
    this.o28_1 = $adler;
    this.m28_1 = $i;
  }
  m1s($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_close__nh2uv0_2.bind(VOID, this), $completion);
  }
  u1v($completion) {
    return this.m28_1.u1v($completion);
  }
  d1v($completion) {
    return this.m28_1.d1v($completion);
  }
  c1v($completion) {
    return this.m28_1.c1v($completion);
  }
  l1s(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_1.bind(VOID, this, buffer, offset, len), $completion);
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function resetAlloc($this) {
  $this.g24_1 = 0;
}
function alloc($this, value, left, right) {
  // Inline function 'kotlin.apply' call
  var _unary__edvuaz = $this.g24_1;
  $this.g24_1 = _unary__edvuaz + 1 | 0;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.compression.deflate.HuffmanTree.alloc.<anonymous>' call
  $this.d24_1[_unary__edvuaz] = value;
  $this.e24_1[_unary__edvuaz] = left;
  $this.f24_1[_unary__edvuaz] = right;
  return _unary__edvuaz;
}
function allocLeaf($this, value) {
  return alloc($this, value, 1023, 1023);
}
function allocNode($this, left, right) {
  return alloc($this, -1, left, right);
}
function computeFastLookup($this) {
  fill($this.j24_1, -1);
  computeEncodedValues($this, $this.h24_1, 0, 0);
}
function computeEncodedValues($this, node, encoded, encodedBits) {
  // Inline function 'korlibs.compression.deflate.HuffmanTree.value' call
  if ($this.d24_1[node] === -1) {
    if (encodedBits < 10) {
      // Inline function 'korlibs.compression.deflate.HuffmanTree.left' call
      var tmp$ret$1 = $this.e24_1[node];
      computeEncodedValues($this, tmp$ret$1, encoded, encodedBits + 1 | 0);
      // Inline function 'korlibs.compression.deflate.HuffmanTree.right' call
      var tmp$ret$2 = $this.f24_1[node];
      computeEncodedValues($this, tmp$ret$2, encoded | 1 << encodedBits, encodedBits + 1 | 0);
    } else {
      writeVariants($this, encoded, encodedBits, node, -2);
    }
  } else {
    // Inline function 'korlibs.compression.deflate.HuffmanTree.value' call
    var tmp$ret$3 = $this.d24_1[node];
    writeVariants($this, encoded, encodedBits, node, tmp$ret$3);
  }
}
function writeVariants($this, encoded, encodedBits, node, nvalue) {
  var encodedInfo = nvalue & 65535 | encodedBits << 16;
  var rangeCount = 1 << (10 - encodedBits | 0);
  var inductionVariable = 0;
  if (inductionVariable < rangeCount)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var i = encoded | n << encodedBits;
      $this.j24_1[i] = encodedInfo;
      $this.k24_1[i] = node;
    }
     while (inductionVariable < rangeCount);
}
function *_generator_compress__c9auau($this, i, o, level, $completion) {
  $l$loop: while (true) {
    var tmp = i.t1w($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    if (!tmp) {
      break $l$loop;
    }
    var tmp_0 = i.u1w($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var available = tmp_0;
    // Inline function 'kotlin.math.min' call
    var b = new Long(65535, 0);
    var chunkSize = (available.z1(b) <= 0 ? available : b).l2();
    var tmp_1 = o.p24(toLong(chunkSize).z1(available) >= 0 ? 1 : 0, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp_2 = o.q24(chunkSize, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var tmp_3 = o.q24(~chunkSize, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    var tmp_4 = i.r24(chunkSize, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    var tmp_5 = o.s24(tmp_4, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
  }
  return Unit_instance;
}
function *_generator_uncompress__ej2bxp($this, reader, out, $completion) {
  var sout = new SlidingWindowWithOutput(new SlidingWindow($this.t24_1), out, reader.u24(), reader.v24());
  var lastBlock = false;
  var tempTree = new HuffmanTree();
  var tempDist = new HuffmanTree();
  var codeLenCodeLen = new Int32Array(32);
  var lengths = new Int32Array(512);
  while (!lastBlock) {
    // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flushIfRequired' call
    if (false || sout.d25()) {
      // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flush' call
      var tmp = sout.x24_1.j1s(sout.a25_1.b25_1, 0, sout.a25_1.c25_1, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      sout.a25_1.m3();
    }
    var tmp_0 = reader.e25($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    lastBlock = reader.f25();
    var blockType = reader.g25(2);
    if (!(0 <= blockType ? blockType <= 2 : false)) {
      // Inline function 'kotlin.error' call
      var message = 'invalid bit';
      throw IllegalStateException.l5(toString(message));
    }
    if (blockType === 0) {
      var len = reader.u25();
      var nlen = reader.u25();
      var nnlen = ~nlen & 65535;
      if (!(len === nnlen)) {
        // Inline function 'kotlin.error' call
        var message_0 = 'Invalid deflate stream: len(' + len + ') != ~nlen(' + nnlen + ') :: nlen=' + nlen;
        throw IllegalStateException.l5(toString(message_0));
      }
      var tmp_1 = reader.v25(len, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var bytes = tmp_1;
      sout.w25(bytes, 0, len);
      // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flushIfRequired' call
      if (false || sout.d25()) {
        // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flush' call
        var tmp_2 = sout.x24_1.j1s(sout.a25_1.b25_1, 0, sout.a25_1.c25_1, $completion);
        if (tmp_2 === get_COROUTINE_SUSPENDED())
          tmp_2 = yield tmp_2;
        sout.a25_1.m3();
      }
    } else {
      var tree;
      var dist;
      if (blockType === 1) {
        tree = Companion_getInstance_1().i25_1;
        dist = Companion_getInstance_1().j25_1;
      } else {
        var hlit = reader.g25(5) + 257 | 0;
        var hdist = reader.g25(5) + 1 | 0;
        var hclen = reader.g25(4) + 4 | 0;
        fill(codeLenCodeLen, 0);
        var inductionVariable = 0;
        if (inductionVariable < hclen)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            codeLenCodeLen[Companion_getInstance_1().o25_1[i]] = reader.g25(3);
          }
           while (inductionVariable < hclen);
        tempTree.p25(codeLenCodeLen);
        var codeLen = tempTree;
        var hlithdist = hlit + hdist | 0;
        var n = 0;
        fill(lengths, 0);
        while (n < hlithdist) {
          // Inline function 'korlibs.compression.deflate.DeflaterPortable.read' call
          var value = codeLen.q25(reader);
          if (!(0 <= value ? value <= 18 : false)) {
            // Inline function 'kotlin.error' call
            throw IllegalStateException.l5(toString('Invalid'));
          }
          var len_0;
          switch (value) {
            case 16:
              len_0 = reader.g25(2) + 3 | 0;
              break;
            case 17:
              len_0 = reader.g25(3) + 3 | 0;
              break;
            case 18:
              len_0 = reader.g25(7) + 11 | 0;
              break;
            default:
              len_0 = 1;
              break;
          }
          var vv;
          switch (value) {
            case 16:
              vv = lengths[n - 1 | 0];
              break;
            case 17:
              vv = 0;
              break;
            case 18:
              vv = 0;
              break;
            default:
              vv = value;
              break;
          }
          fill(lengths, vv, n, n + len_0 | 0);
          n = n + len_0 | 0;
        }
        tempTree.r25(lengths, 0, hlit);
        tempDist.r25(lengths, hlit, hlithdist);
        tree = tempTree;
        dist = tempDist;
      }
      $l$loop: while (true) {
        var tmp_3 = reader.e25($completion);
        if (tmp_3 === get_COROUTINE_SUSPENDED())
          tmp_3 = yield tmp_3;
        var value_0 = tree.q25(reader);
        if (value_0 === 256)
          break $l$loop;
        if (value_0 < 256) {
          sout.t25(toByte(value_0));
        } else {
          var zlenof = value_0 - 257 | 0;
          var lengthExtra = reader.g25(Companion_getInstance_1().k25_1[zlenof]);
          // Inline function 'korlibs.compression.deflate.DeflaterPortable.read' call
          var distanceData = dist.q25(reader);
          var distanceExtra = reader.g25(Companion_getInstance_1().m25_1[distanceData]);
          var distance = Companion_getInstance_1().n25_1[distanceData] + distanceExtra | 0;
          var length = Companion_getInstance_1().l25_1[zlenof] + lengthExtra | 0;
          sout.s25(distance, length);
        }
        // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flushIfRequired' call
        if (false || sout.d25()) {
          // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flush' call
          var tmp_4 = sout.x24_1.j1s(sout.a25_1.b25_1, 0, sout.a25_1.c25_1, $completion);
          if (tmp_4 === get_COROUTINE_SUSPENDED())
            tmp_4 = yield tmp_4;
          sout.a25_1.m3();
        }
      }
    }
  }
  // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flushIfRequired' call
  if (true || sout.d25()) {
    // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flush' call
    var tmp_5 = sout.x24_1.j1s(sout.a25_1.b25_1, 0, sout.a25_1.c25_1, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    sout.a25_1.m3();
  }
  return Unit_instance;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
function get_unsigned(_this__u8e3s4) {
  return _this__u8e3s4 & 255;
}
function arraycopy(src, srcPos, dst, dstPos, size) {
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = srcPos + size | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
}
function toDeflater(_this__u8e3s4) {
  return new toDeflater$1(_this__u8e3s4);
}
function *_generator_forInput__mjt6c9($this, s, $completion) {
  var tmp;
  if (isInterface(s, AsyncGetLengthStream)) {
    var tmp_0 = s.d1v($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  if (tmp) {
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.min' call
    var tmp_1 = s.c1v($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var a = tmp_1;
    var b = new Long(8388608, 0);
    var b_0 = (a.z1(b) <= 0 ? a : b).l2();
    var bigChunkSize = Math.max(32768, b_0);
    // Inline function 'kotlin.math.max' call
    var a_0 = bigChunkSize / 2 | 0;
    var readWithSize = Math.max(a_0, 32768);
    return new BitReader(s, bigChunkSize, readWithSize);
  }
  return new BitReader(s);
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
function *_generator_prepareBytesUpTo__5zpo26($this, expectedBytes, $completion) {
  $l$loop_0: while ($this.x26_1.e16_1 < expectedBytes) {
    // Inline function 'kotlin.math.min' call
    var b = $this.x26_1.b17();
    var readCount = Math.min(expectedBytes, b);
    if (readCount <= 0)
      break $l$loop_0;
    var tmp = $this.s26_1.l1s($this.x26_1.v16(), $this.x26_1.x16(), readCount, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var transferred = tmp;
    if (transferred <= 0)
      break $l$loop_0;
    $this.x26_1.y16(transferred);
    $this.z26_1 = $this.z26_1 + transferred;
  }
  return Unit_instance;
}
function *_generator_abytes__gje57m($this, count, out, $completion) {
  var tmp = $this.b27(count, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.c27(count, out);
}
function *_generator_read__qih2oe($this, buffer, offset, len, $completion) {
  var tmp = $this.b27(len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var out = $this.x26_1.o16(buffer, offset, len);
  $this.y26_1 = $this.y26_1 + out;
  return out;
}
function *_generator_close__nh2uv0($this, $completion) {
  var tmp = $this.s26_1.m1s($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_strz__qhnc5d($this, $completion) {
  // Inline function 'korlibs.io.stream.MemorySyncStreamToByteArray' call
  var buffer = ByteArrayBuilder.sv(4096);
  var s = MemorySyncStream(buffer);
  // Inline function 'korlibs.compression.deflate.BitReader.strz.<anonymous>' call
  // Inline function 'korlibs.compression.deflate.BitReader.discardBits' call
  $this.v26_1 = 0;
  $this.w26_1 = 0;
  $l$loop: while (true) {
    // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
    if ($this.d27()) {
      var tmp = $this.b27($this.t26_1, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
    // Inline function 'korlibs.compression.deflate.BitReader._su8' call
    $this.y26_1 = $this.y26_1 + 1;
    var c = $this.x26_1.e17();
    if (c === 0)
      break $l$loop;
    write8(s, c);
  }
  var tmp$ret$2 = buffer.xv();
  return toString_0(tmp$ret$2, ASCII_getInstance());
}
function *_generator_hasLength__5f5ox8($this, $completion) {
  var tmp = $this.s26_1;
  var tmp2_safe_receiver = isInterface(tmp, AsyncGetLengthStream) ? tmp : null;
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    var tmp_1 = tmp2_safe_receiver.d1v($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  }
  var tmp0_elvis_lhs = tmp_0;
  return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
}
function *_generator_getLength__lvva94($this, $completion) {
  var tmp = $this.s26_1;
  var tmp3_safe_receiver = isInterface(tmp, AsyncGetLengthStream) ? tmp : null;
  var tmp_0;
  if (tmp3_safe_receiver == null) {
    tmp_0 = null;
  } else {
    var tmp_1 = tmp3_safe_receiver.c1v($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  }
  var tmp0_elvis_lhs = tmp_0;
  var tmp_2;
  if (tmp0_elvis_lhs == null) {
    var message = 'Length not available on Stream';
    throw IllegalStateException.l5(toString(message));
  } else {
    tmp_2 = tmp0_elvis_lhs;
  }
  return tmp_2;
}
function toDeflater_0(_this__u8e3s4) {
  return new toDeflater$2(_this__u8e3s4);
}
function ilog2(v) {
  var tmp;
  if (v === 0) {
    tmp = -1;
  } else {
    // Inline function 'kotlin.countLeadingZeroBits' call
    tmp = 31 - clz32(v) | 0;
  }
  return tmp;
}
function get_nextPowerOfTwo(_this__u8e3s4) {
  var v = _this__u8e3s4;
  v = v - 1 | 0;
  v = v | v >> 1;
  v = v | v >> 2;
  v = v | v >> 4;
  v = v | v >> 8;
  v = v | v >> 16;
  v = v + 1 | 0;
  return v;
}
function *_generator_prepareBigChunkIfRequired__yhuuys($this, $completion) {
  // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
  var this_0 = $this.l27_1;
  if (this_0.d27()) {
    var tmp = this_0.b27(this_0.t26_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_uncompress__ej2bxp_0($this, i, o, $completion) {
  var tmp = $this.h26(toDeflater(new BitReader(i)), toDeflater_0(o), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_compress__c9auau_0($this, i, o, context, $completion) {
  var tmp = $this.f26(toDeflater(new BitReader(i)), toDeflater_0(o), context.n27_1 / 10.0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function uncompressed(_this__u8e3s4, method, bufferSize, $completion) {
  bufferSize = bufferSize === VOID ? 8388608 : bufferSize;
  return uncompressStream(method, _this__u8e3s4, bufferSize, $completion);
}
function uncompress_1(_this__u8e3s4, method, outputSizeHint) {
  outputSizeHint = outputSizeHint === VOID ? imul(_this__u8e3s4.length, 2) : outputSizeHint;
  return uncompress_2(method, _this__u8e3s4, outputSizeHint);
}
function compress_1(_this__u8e3s4, method, context, outputSizeHint) {
  context = context === VOID ? new CompressionContext(method.j26()) : context;
  outputSizeHint = outputSizeHint === VOID ? numberToInt(_this__u8e3s4.length * 1.1) : outputSizeHint;
  return compress_2(method, _this__u8e3s4, context, outputSizeHint);
}
function uncompressStream(_this__u8e3s4, input, bufferSize, $completion) {
  bufferSize = bufferSize === VOID ? 8388608 : bufferSize;
  var tmp = 'uncompress:' + toString(_this__u8e3s4);
  return asyncStreamWriter(bufferSize, tmp, false, uncompressStream$slambda_0(_this__u8e3s4, input), $completion);
}
function uncompress_2(_this__u8e3s4, bytes, outputSizeHint) {
  outputSizeHint = outputSizeHint === VOID ? imul(bytes.length, 2) : outputSizeHint;
  // Inline function 'korlibs.io.stream.MemorySyncStreamToByteArray' call
  var buffer = ByteArrayBuilder.sv(outputSizeHint);
  var s = MemorySyncStream(buffer);
  // Inline function 'korlibs.io.compression.uncompress.<anonymous>' call
  uncompress_3(_this__u8e3s4, openSync(bytes), s);
  return buffer.xv();
}
function compress_2(_this__u8e3s4, bytes, context, outputSizeHint) {
  context = context === VOID ? new CompressionContext(_this__u8e3s4.j26()) : context;
  outputSizeHint = outputSizeHint === VOID ? numberToInt(bytes.length * 1.1) : outputSizeHint;
  // Inline function 'korlibs.io.stream.MemorySyncStreamToByteArray' call
  var buffer = ByteArrayBuilder.sv(outputSizeHint);
  var s = MemorySyncStream(buffer);
  // Inline function 'korlibs.io.compression.compress.<anonymous>' call
  compress_3(_this__u8e3s4, openSync(bytes), s, context);
  return buffer.xv();
}
function uncompress_3(_this__u8e3s4, i, o) {
  return runBlockingNoSuspensions(uncompress$slambda_0(_this__u8e3s4, i, o));
}
function compress_3(_this__u8e3s4, i, o, context) {
  context = context === VOID ? new CompressionContext(_this__u8e3s4.j26()) : context;
  return runBlockingNoSuspensions(compress$slambda_0(_this__u8e3s4, i, o, context));
}
function *_generator_invoke__zhh2q8($this, output, $completion) {
  var tmp = $this.q27_1.i26($this.r27_1, output, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function uncompressStream$slambda_0($this_uncompressStream, $input) {
  var i = new uncompressStream$slambda($this_uncompressStream, $input);
  var l = function (output, $completion) {
    return i.s27(output, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = $this.t27_1.i26(toAsync($this.u27_1), toAsync_0($this.v27_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function uncompress$slambda_0($this_uncompress, $i, $o) {
  var i = new uncompress$slambda($this_uncompress, $i, $o);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = $this.w27_1.g26(toAsync($this.x27_1), toAsync_0($this.y27_1), $this.z27_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function compress$slambda_0($this_compress, $i, $o, $context) {
  var i = new compress$slambda($this_compress, $i, $o, $context);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function get_Deflate() {
  _init_properties_Deflate_kt__jbr9mv();
  // Inline function 'kotlin.getValue' call
  var this_0 = Deflate$delegate;
  Deflate$factory();
  return this_0.u1();
}
var Deflate$delegate;
function Deflate(windowBits) {
  _init_properties_Deflate_kt__jbr9mv();
  return DeflaterNative(windowBits);
}
function Deflate$delegate$lambda() {
  _init_properties_Deflate_kt__jbr9mv();
  return Deflate(15);
}
function Deflate$factory() {
  return getPropertyCallableRef('Deflate', 0, KProperty0, function () {
    return get_Deflate();
  }, null);
}
var properties_initialized_Deflate_kt_5ek8zp;
function _init_properties_Deflate_kt__jbr9mv() {
  if (!properties_initialized_Deflate_kt_5ek8zp) {
    properties_initialized_Deflate_kt_5ek8zp = true;
    Deflate$delegate = lazy(Deflate$delegate$lambda);
  }
}
function GZIP$Companion$_init_$lambda_4zsoc7() {
  return get_Deflate();
}
var Companion_instance_3;
function Companion_getInstance_3() {
  if (Companion_instance_3 === VOID)
    new Companion_3();
  return Companion_instance_3;
}
function *_generator_write__x1694l($this, byte, $completion) {
  var tmp = $this.c28_1.n1s(byte, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_close__nh2uv0_0($this, $completion) {
  var tmp = $this.c28_1.m1s($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_write__x1694l_0($this, buffer, offset, len, $completion) {
  if (len > 0) {
    $this.e28_1._v = CRC32_getInstance().p23($this.e28_1._v, buffer, offset, len);
    $this.f28_1._v = $this.f28_1._v + len | 0;
    var tmp = $this.d28_1.j1s(buffer, offset, len, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_close__nh2uv0_1($this, $completion) {
  var tmp = $this.g28_1.m1s($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_read__qih2oe_0($this, buffer, offset, len, $completion) {
  var tmp = $this.h28_1.l1s(buffer, offset, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var read = tmp;
  if (read > 0) {
    $this.i28_1._v = CRC32_getInstance().p23($this.i28_1._v, buffer, offset, read);
    $this.j28_1._v = $this.j28_1._v + read | 0;
  }
  return read;
}
function *_generator_uncompress__ej2bxp_1($this, i, out, $completion) {
  var r = new BitReader(i);
  // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
  if (r.d27()) {
    var tmp = r.b27(r.t26_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  var h0 = r.f27();
  var h1 = r.f27();
  if (!(h0 === 31) || !(h1 === 139)) {
    // Inline function 'kotlin.error' call
    var message = 'Not a GZIP file (h0=' + toHexString(toByte(h0)) + ', h1=' + toHexString(toByte(h1)) + ')';
    throw IllegalStateException.l5(toString(message));
  }
  var method = r.f27();
  if (!(method === 8)) {
    // Inline function 'kotlin.error' call
    var message_0 = 'Just supported deflate in GZIP (method=' + method + ')';
    throw IllegalStateException.l5(toString(message_0));
  }
  var ftext = r.f25();
  var fhcrc = r.f25();
  var fextra = r.f25();
  var fname = r.f25();
  var fcomment = r.f25();
  var reserved = r.g25(3);
  var mtime = r.g27();
  var xfl = r.f27();
  var os = r.f27();
  var tmp_0;
  if (fextra) {
    var tmp_1 = r.j27(r.u25(), VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } else {
    // Inline function 'kotlin.byteArrayOf' call
    tmp_0 = new Int8Array([]);
  }
  var extra = tmp_0;
  var tmp_2;
  if (fname) {
    var tmp_3 = r.k27($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_2 = tmp_3;
  } else {
    tmp_2 = null;
  }
  var name = tmp_2;
  var tmp_4;
  if (fcomment) {
    var tmp_5 = r.k27($completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    tmp_4 = tmp_5;
  } else {
    tmp_4 = null;
  }
  var comment = tmp_4;
  var crc16 = fhcrc ? r.u25() : 0;
  var ccrc32 = {_v: CRC32_getInstance().r23_1};
  var csize = {_v: 0};
  var tmp_6 = $this.b28_1();
  var tmp_7 = isInterface(tmp_6, IDeflaterInternal) ? tmp_6 : THROW_CCE();
  var tmp_8 = toDeflater(r);
  var tmp_9 = tmp_7.h26(tmp_8, toDeflater_0(new GZIPBase$uncompress$2(out, ccrc32, csize)), $completion);
  if (tmp_9 === get_COROUTINE_SUSPENDED())
    tmp_9 = yield tmp_9;
  // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
  if (r.d27()) {
    var tmp_10 = r.b27(r.t26_1, $completion);
    if (tmp_10 === get_COROUTINE_SUSPENDED())
      tmp_10 = yield tmp_10;
  }
  var crc32 = r.g27();
  var size = r.g27();
  if ($this.a28_1 && (!(csize._v === size) || !(ccrc32._v === crc32))) {
    invalidOp("Size doesn't match SIZE(" + toHexString_0(csize._v) + ' != ' + toHexString_0(size) + ') || CRC32(' + toHexString_0(ccrc32._v) + ' != ' + toHexString_0(crc32) + ')');
  }
  return Unit_instance;
}
function *_generator_compress__c9auau_1($this, i, o, context, $completion) {
  var i_0 = new BitReader(i);
  var tmp = write8_0(o, 31, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = write8_0(o, 139, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = write8_0(o, 8, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = write8_0(o, 0, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = write32LE(o, 0, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp_4 = write8_0(o, 0, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp_5 = write8_0(o, 0, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var size = {_v: 0};
  var crc32 = {_v: CRC32_getInstance().r23_1};
  var tmp_6 = $this.b28_1();
  var tmp_7 = Companion_instance_2;
  var tmp_8 = tmp_7.r26(new GZIPBase$compress$2(i_0, crc32, size), $completion);
  if (tmp_8 === get_COROUTINE_SUSPENDED())
    tmp_8 = yield tmp_8;
  var tmp_9 = tmp_6.g26(tmp_8, o, context, $completion);
  if (tmp_9 === get_COROUTINE_SUSPENDED())
    tmp_9 = yield tmp_9;
  var tmp_10 = write32LE(o, crc32._v, $completion);
  if (tmp_10 === get_COROUTINE_SUSPENDED())
    tmp_10 = yield tmp_10;
  var tmp_11 = write32LE(o, size._v, $completion);
  if (tmp_11 === get_COROUTINE_SUSPENDED())
    tmp_11 = yield tmp_11;
  return Unit_instance;
}
function ZLib$Companion$_init_$lambda_nrgg4o(it) {
  return Deflate(it);
}
function *_generator_write__x1694l_1($this, buffer, offset, len, $completion) {
  var tmp = $this.k28_1.j1s(buffer, offset, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.l28_1._v = Adler32_instance.p23($this.l28_1._v, buffer, offset, len);
  return Unit_instance;
}
function *_generator_close__nh2uv0_2($this, $completion) {
  var tmp = $this.m28_1.m1s($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_read__qih2oe_1($this, buffer, offset, len, $completion) {
  var tmp = $this.n28_1.l1s(buffer, offset, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var read = tmp;
  if (read > 0) {
    $this.o28_1._v = Adler32_instance.p23($this.o28_1._v, buffer, offset, read);
  }
  return read;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
function *_generator_uncompress__ej2bxp_2($this, i, o, $completion) {
  var r = new BitReader(i);
  // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
  if (r.d27()) {
    var tmp = r.b27(r.t26_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  var cmf = r.f27();
  var flg = r.f27();
  if (!(((imul(cmf, 256) + flg | 0) % 31 | 0) === 0)) {
    // Inline function 'kotlin.error' call
    var message = 'bad zlib header';
    throw IllegalStateException.l5(toString(message));
  }
  var compressionMethod = extract(cmf, 0, 4);
  if (!(compressionMethod === 8)) {
    // Inline function 'kotlin.error' call
    var message_0 = 'Invalid zlib stream compressionMethod=' + compressionMethod;
    throw IllegalStateException.l5(toString(message_0));
  }
  var windowBits = extract(cmf, 4, 4) + 8 | 0;
  var fcheck = extract(flg, 0, 5);
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  var hasDict = !(((flg >>> 5 | 0) & 1) === 0);
  var flevel = extract(flg, 6, 2);
  var dictid = 0;
  if (hasDict) {
    dictid = r.g27();
    // Inline function 'kotlin.TODO' call
    var reason = 'Unsupported custom dictionaries (Provided DICTID=' + dictid + ')';
    throw NotImplementedError.ee('An operation is not implemented: ' + reason);
  }
  var chash = {_v: Adler32_instance.o23_1};
  var tmp_0 = $this.p28_1(windowBits);
  var tmp_1 = isInterface(tmp_0, IDeflaterInternal) ? tmp_0 : THROW_CCE();
  var tmp_2 = toDeflater(r);
  var tmp_3 = tmp_1.h26(tmp_2, toDeflater_0(new ZLib$uncompress$2(o, chash)), $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
  if (r.d27()) {
    var tmp_4 = r.b27(r.t26_1, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
  }
  var adler32 = r.h27();
  if (!(chash._v === adler32)) {
    invalidOp("Adler32 doesn't match " + toHexString_0(chash._v) + ' != ' + toHexString_0(adler32));
  }
  return Unit_instance;
}
function *_generator_compress__c9auau_2($this, i, o, context, $completion) {
  var i_0 = new BitReader(i);
  var slidingBits = 15;
  var clevel = context.n27_1 <= 0 ? 0 : context.n27_1 < 6 ? 1 : context.n27_1 < 9 ? 2 : 3;
  var cmf = 8 | (slidingBits - 8 | 0) << 4;
  var flg = 0 | clevel << 6;
  var fcheck = 0;
  var inductionVariable = 0;
  if (inductionVariable < 32)
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (((imul(cmf, 256) + (flg | n) | 0) % 31 | 0) === 0) {
        fcheck = n;
        break $l$loop;
      }
    }
     while (inductionVariable < 32);
  var tmp = write8_0(o, cmf, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = write8_0(o, flg | fcheck, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var adler = {_v: Adler32_instance.o23_1};
  var tmp_1 = $this.p28_1(slidingBits);
  var tmp_2 = isInterface(tmp_1, IDeflaterInternal) ? tmp_1 : THROW_CCE();
  var tmp_3 = tmp_2.f26(toDeflater(new BitReader(new ZLib$compress$2(i_0, adler))), toDeflater_0(o), context.n27_1 / 10.0, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp_4 = write32BE(o, adler._v, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  return Unit_instance;
}
function DeflaterNative(windowBits) {
  return new DeflaterPortable(windowBits);
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForCompanion(Companion_0);
initMetadataForClass(SlidingWindowWithOutput, 'SlidingWindowWithOutput', VOID, VOID, VOID, [0, 1]);
initMetadataForInterface(CompressionMethod, 'CompressionMethod', VOID, VOID, VOID, [2, 3]);
initMetadataForInterface(IDeflaterInternal, 'IDeflaterInternal', VOID, VOID, [CompressionMethod], [2, 3]);
protoOf(DeflaterPortable).i26 = uncompress_0;
protoOf(DeflaterPortable).g26 = compress_0;
protoOf(DeflaterPortable).j26 = get_level;
initMetadataForClass(DeflaterPortable, 'DeflaterPortable', VOID, VOID, [IDeflaterInternal], [3, 2]);
initMetadataForCompanion(Companion_1, VOID, VOID, [3, 2]);
initMetadataForClass(HuffmanTree, 'HuffmanTree', HuffmanTree);
initMetadataForClass(SlidingWindow, 'SlidingWindow');
initMetadataForClass(FixedSizeByteArrayBuilder, 'FixedSizeByteArrayBuilder');
initMetadataForCompanion(Companion_2, VOID, VOID, [1]);
initMetadataForClass(BitReader, 'BitReader', VOID, VOID, [AsyncGetPositionStream, AsyncGetLengthStream], [0, 1, 2, 3]);
initMetadataForClass(toDeflater$1, VOID, VOID, VOID, VOID, [0, 1, 3]);
initMetadataForClass(toDeflater$2, VOID, VOID, VOID, VOID, [3, 1]);
initMetadataForClass(CompressionContext, 'CompressionContext', CompressionContext);
initMetadataForLambda(uncompressStream$slambda, VOID, VOID, [1]);
initMetadataForLambda(uncompress$slambda, VOID, VOID, [0]);
initMetadataForLambda(compress$slambda, VOID, VOID, [0]);
protoOf(GZIPBase).j26 = get_level;
initMetadataForClass(GZIPBase, 'GZIPBase', VOID, VOID, [CompressionMethod], [2, 3]);
initMetadataForClass(GZIP, 'GZIP', VOID, VOID, VOID, [2, 3]);
initMetadataForCompanion(Companion_3, VOID, VOID, [2, 3]);
protoOf(GZIPBase$uncompress$2).k1s = write$default;
initMetadataForClass(GZIPBase$uncompress$2, VOID, VOID, VOID, [AsyncOutputStream], [1, 0, 3]);
initMetadataForClass(GZIPBase$compress$2, VOID, VOID, VOID, [AsyncGetPositionStream, AsyncGetLengthStream], [0, 3]);
protoOf(ZLib).j26 = get_level;
initMetadataForClass(ZLib, 'ZLib', VOID, VOID, [CompressionMethod], [2, 3]);
initMetadataForCompanion(Companion_4, VOID, VOID, [2, 3]);
protoOf(ZLib$uncompress$2).k1s = write$default;
protoOf(ZLib$uncompress$2).n1s = write;
initMetadataForClass(ZLib$uncompress$2, VOID, VOID, VOID, [AsyncOutputStream], [0, 3, 1]);
initMetadataForClass(ZLib$compress$2, VOID, VOID, VOID, [AsyncGetPositionStream, AsyncGetLengthStream], [0, 3]);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_2 = new Companion_2();
//endregion
//region block: exports
export {
  uncompressed as uncompressed1upyct1udgysk,
  Companion_getInstance_3 as Companion_getInstance21eog9dvyf17t,
  Companion_getInstance_4 as Companion_getInstance3mocpl8hga9iq,
  get_Deflate as get_Deflate2a0lyute7oxjd,
  CompressionContext as CompressionContext8cgnuxsl0ava,
  compress_1 as compress1visp4hlh2b1n,
  uncompress_1 as uncompress3ofkd276wd0zn,
};
//endregion
